module.exports = __webpack_public_path__ + "static/media/cotyBanner-tablet-738x57@1x.07ae29fe.jpg";